import { Box, Typography } from '@mui/material';

const buildPercentLabel = (label: string, totalPercent: number) => (
  <Box display="inline-flex" flexDirection="column" alignItems="flex-start" textAlign="left">
    <Typography variant="subtitle2" fontWeight="500">
      {label}
    </Typography>
    <Typography variant="subtitle2" fontWeight="500">
      (Total: {totalPercent}%)
    </Typography>
  </Box>
);

export const getMinPercentLabel = (totalMinPercent: number) => buildPercentLabel('Min percent', totalMinPercent);

export const getMaxPercentLabel = (totalMaxPercent: number) => buildPercentLabel('Max percent', totalMaxPercent);
